
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/cookies-policy",
      function () {
        return require("private-next-pages/legal/cookies-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/cookies-policy"])
      });
    }
  